export default __webpack_public_path__ + "static/media/Icon awesome-user-alt.96fcdb30.svg";